// Catálogo común para menú, rutas y permisos; incluye los informes de Came.
const navigation = [
  {
    type: "collapse",
    name: "Home",
    key: "dashboard",
    iconKey: "HomeIcon",
    route: "/dashboard",
    componentKey: "Dashboard",
    public: true,
    permissionKey: "dashboard",
  },
  {
    type: "collapse",
    name: "Mantenimiento",
    key: "mantenimiento",
    iconKey: "HandymanIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Agendamiento",
        key: "agendamiento",
        iconKey: "CalendarMonthIcon",
        route: "/agendamiento",
        componentKey: "Schedule",
        public: false,
        permissionKey: "agendamiento",
      },
      {
        type: "collapse",
        name: "Ordenes",
        key: "ordenes",
        iconKey: "AssignmentIcon",
        route: "/ordenes",
        componentKey: "JobOrder",
        public: false,
        permissionKey: "ordenes",
      },
      {
        type: "collapse",
        name: "Configuracion",
        key: "configuracion",
        iconKey: "SettingsIcon",
        route: "/configuracion",
        componentKey: "Configuracion",
        public: false,
        permissionKey: "configuracion",
      },
    ],
    public: false,
    permissionKey: "mantenimiento",
  },
  {
    type: "collapse",
    name: "Came",
    key: "came",
    iconKey: "LocalActivityIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Cierre",
        key: "cierre",
        iconKey: "LockClockIcon",
        route: "/cierre",
        componentKey: "Cierre",
        public: false,
        permissionKey: "cierre",
      },
      {
        type: "collapse",
        name: "Vip Came",
        key: "vipCame",
        iconKey: "WorkspacePremiumIcon",
        route: "/vipCame",
        componentKey: "VipCame",
        public: false,
        permissionKey: "vipCame",
      },
      {
        type: "collapse",
        name: "InformeDiario",
        key: "informeDiario",
        iconKey: "SummarizeIcon",
        route: "/informeDiario",
        componentKey: "Informe",
        public: false,
        permissionKey: "informeDiario",
      },
      {
        type: "collapse",
        name: "Bicicletas",
        key: "bicicletas",
        iconKey: "PedalBikeIcon",
        route: "/bicicletas",
        componentKey: "Bicicletas",
        public: false,
        permissionKey: "bicicletas",
      },
      {
        type: "collapse",
        name: "Frecuencia",
        key: "frecuencia",
        iconKey: "UpdateIcon",
        route: "/frecuencia",
        componentKey: "Frecuencia",
        public: false,
        permissionKey: "bicicletas",
        // Compatibilidad: la ruta usa bicicletas; el editor ya ofrecía frecuencia.
        // Cambiar esta regla requiere migrar los permisos existentes en backend.
        availablePermissionKey: "frecuencia",
      },
      {
        type: "collapse",
        name: "Permanencia",
        key: "permanencia",
        iconKey: "HourglassEmptyIcon",
        route: "/permanencia",
        componentKey: "Permanencia",
        public: false,
        permissionKey: "permanencia",
      },
      {
        type: "collapse",
        name: "Uso de VIP",
        key: "usoVip",
        iconKey: "WorkspacePremiumIcon",
        route: "/usoVip",
        componentKey: "UsoVip",
        public: false,
        permissionKey: "usoVip",
      },
    ],
    public: false,
    permissionKey: "came",
  },
  {
    type: "collapse",
    name: "Copropiedades",
    key: "copropiedades",
    iconKey: "ApartmentIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Edificio",
        key: "edificio",
        iconKey: "LocationCityIcon",
        route: "/edificio",
        componentKey: "Edificio",
        public: false,
        permissionKey: "edificio",
      },
      {
        type: "collapse",
        name: "Administracion",
        key: "administracion",
        iconKey: "ManageAccountsIcon",
        route: "/administracion",
        componentKey: "Administracion",
        public: false,
        permissionKey: "administracion",
      },
      {
        type: "collapse",
        name: "Propiedades",
        key: "propiedades",
        iconKey: "HomeWorkIcon",
        route: "/propiedades",
        componentKey: "Propiedades",
        public: false,
        permissionKey: "propiedades",
      },
      {
        type: "collapse",
        name: "Permisos",
        key: "permisos",
        iconKey: "VpnKeyIcon",
        route: "/permisos",
        componentKey: "Permisos",
        public: false,
        permissionKey: "permisos",
      },
    ],
    public: false,
    permissionKey: "copropiedades",
  },
  {
    type: "collapse",
    name: "Tags",
    key: "tags",
    iconKey: "LocalOfferIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Carga",
        key: "carga",
        iconKey: "UploadFileIcon",
        route: "/carga",
        componentKey: "Tags",
        public: false,
        permissionKey: "carga",
      },
    ],
    public: false,
    permissionKey: "tags",
  },
  {
    type: "collapse",
    name: "Lazo",
    key: "lazo",
    iconKey: "AllInclusiveIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Carga Lazo",
        key: "cargalazo",
        iconKey: "PublishIcon",
        route: "/cargalazo",
        componentKey: "Lazo",
        public: false,
        permissionKey: "cargalazo",
      },
    ],
    public: false,
    permissionKey: "lazo",
  },
  {
    type: "collapse",
    name: "Financiera",
    key: "financiera",
    iconKey: "AccountBalanceWalletIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Facturas",
        key: "facturas",
        iconKey: "ReceiptLongIcon",
        route: "/facturas",
        componentKey: "Facturas",
        public: false,
        permissionKey: "facturas",
      },
      {
        type: "collapse",
        name: "Recaudo",
        key: "recaudo",
        iconKey: "SavingsIcon",
        route: "/recaudo",
        componentKey: "Aseguramiento",
        public: false,
        permissionKey: "recaudo",
      },
    ],
    public: false,
    permissionKey: "financiera",
  },
  {
    type: "collapse",
    name: "Tableros",
    key: "tableros",
    iconKey: "SpaceDashboardIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Comercios",
        key: "comercios",
        iconKey: "StorefrontIcon",
        route: "/comercios",
        componentKey: "TableroSac",
        public: false,
        permissionKey: "comercios",
      },
      {
        type: "collapse",
        name: "Tablero Gerencial",
        key: "tablerogerencial",
        iconKey: "QueryStatsIcon",
        route: "/tablerogerencial",
        componentKey: "TableroGerencia",
        public: false,
        permissionKey: "tablerogerencial",
      },
    ],
    public: false,
    permissionKey: "tableros",
  },
  {
    type: "collapse",
    name: "FinOps",
    key: "finops",
    iconKey: "CurrencyExchangeIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Información de concesión",
        key: "infoConcesion",
        iconKey: "BusinessIcon",
        route: "/infoConcesion",
        componentKey: "InfoConcesion",
        public: false,
        permissionKey: "infoConcesion",
      },
      {
        type: "collapse",
        name: "Gestion Conciliaciones",
        key: "gestionConciliaciones",
        iconKey: "FactCheckIcon",
        route: "/gestionConciliaciones",
        componentKey: "GestionConciliaciones",
        public: false,
        permissionKey: "gestionConciliaciones",
      },
      {
        type: "collapse",
        name: "Configuracion peajes",
        key: "configuracionPeajes",
        iconKey: "SettingsSuggestIcon",
        route: "/configuracionPeajes",
        componentKey: "ConfiguracionPeajes",
        public: false,
        permissionKey: "configuracionPeajes",
      },
      {
        type: "collapse",
        name: "Lotes",
        key: "lotes",
        iconKey: "Inventory2Icon",
        route: "/lotes",
        componentKey: "Lotes",
        public: false,
        permissionKey: "lotes",
      },
      {
        type: "collapse",
        name: "Lotes Financiera",
        key: "lotesFinanciera",
        iconKey: "AccountTreeIcon",
        route: "/lotesFinanciera",
        componentKey: "LotesFinanciera",
        public: false,
        permissionKey: "lotesFinanciera",
      },
      {
        type: "collapse",
        name: "Reportes",
        key: "reportesGroup",
        availablePermissionKey: "reportes",
        iconKey: "AssessmentIcon",
        route: null,
        collapse: [
          {
            type: "collapse",
            name: "Pasos rechazados",
            key: "reportes",
            iconKey: "ReportProblemIcon",
            route: "/reportes",
            componentKey: "Reportes",
            public: false,
            permissionKey: "reportes",
          },
          {
            type: "collapse",
            name: "Correos conciliaciones",
            key: "reportesConciliaciones",
            iconKey: "MarkEmailReadIcon",
            route: "/reportes/conciliaciones",
            componentKey: "ReportesConciliaciones",
            public: false,
            permissionKey: "reportes",
          },
        ],
      },
      {
        type: "collapse",
        name: "Conciliaciones",
        key: "conciliaciones",
        iconKey: "CompareArrowsIcon",
        route: null,
        collapse: [
          {
            type: "collapse",
            name: "Parqueaderos",
            key: "parqueaderos",
            iconKey: "GarageIcon",
            route: null,
            collapse: [
              {
                type: "collapse",
                name: "Financiera1",
                key: "financiera1",
                iconKey: "AccountBalanceIcon",
                route: "/financiera",
                componentKey: "Conciliacion",
                public: false,
                permissionKey: "financiera1",
              },
              {
                type: "collapse",
                name: "Chipichape",
                key: "chipichape",
                iconKey: "ShoppingCartIcon",
                route: "/chipichape",
                componentKey: "Chipichape",
                public: false,
                permissionKey: "chipichape",
              },
              {
                type: "collapse",
                name: "Vizcaya",
                key: "vizcaya",
                iconKey: "ShoppingBagIcon",
                route: "/vizcaya",
                componentKey: "Vizcaya",
                public: false,
                permissionKey: "vizcaya",
              },
              {
                type: "collapse",
                name: "Zpp",
                key: "zpp",
                iconKey: "PinDropIcon",
                route: "/zpp",
                componentKey: "Zpp",
                public: false,
                permissionKey: "zpp",
              },
              {
                type: "collapse",
                name: "Holguines",
                key: "holguines",
                iconKey: "ShoppingBasketIcon",
                route: "/holguines",
                componentKey: "Holguines",
                public: false,
                permissionKey: "holguines",
              },
              {
                type: "collapse",
                name: "Fundadores",
                key: "fundadores",
                iconKey: "MuseumIcon",
                route: "/fundadores",
                componentKey: "Fundadores",
                public: false,
                permissionKey: "fundadores",
              },
            ],
            public: false,
            permissionKey: "parqueaderos",
          },
          {
            type: "collapse",
            name: "Peajes",
            key: "peajes",
            iconKey: "TollIcon",
            route: null,
            collapse: [
              {
                type: "collapse",
                name: "Accenorte",
                key: "accenorte",
                iconKey: "NorthIcon",
                route: "/accenorte",
                componentKey: "Accenorte",
                public: false,
                permissionKey: "accenorte",
              },
              {
                type: "collapse",
                name: "AlcEnvigado",
                key: "alcenvigado",
                iconKey: "GavelIcon",
                route: "/alcaldiaenvigado",
                componentKey: "AlcaEnvigado",
                public: false,
                permissionKey: "alcenvigado",
              },
              {
                type: "collapse",
                name: "Altviales",
                key: "altviales",
                iconKey: "AltRouteIcon",
                route: "/altviales",
                componentKey: "Altviales",
                public: false,
                permissionKey: "altviales",
              },
              {
                type: "collapse",
                name: "Alma",
                key: "alma",
                iconKey: "CommuteIcon",
                route: "/alma",
                componentKey: "Alma",
                public: false,
                permissionKey: "alma",
              },
              {
                type: "collapse",
                name: "Autocafe",
                key: "autocafe",
                iconKey: "LocalCafeIcon",
                route: "/autocafe",
                componentKey: "Autocafe",
                public: false,
                permissionKey: "autocafe",
              },
              {
                type: "collapse",
                name: "AutoNordeste",
                key: "autnordeste",
                iconKey: "NorthEastIcon",
                route: "/autnordeste",
                componentKey: "AutNordeste",
                public: false,
                permissionKey: "autnordeste",
              },
              {
                type: "collapse",
                name: "AutoRioMagdalena",
                key: "autoriomagdalena",
                iconKey: "WaterIcon",
                route: "/autoriomagdalena",
                componentKey: "AutoRioMagdalena",
                public: false,
                permissionKey: "autoriomagdalena",
              },
              {
                type: "collapse",
                name: "Autopista Uraba",
                key: "autopistauraba",
                iconKey: "ForestIcon",
                route: "/autopistauraba",
                componentKey: "AutopistaUraba",
                public: false,
                permissionKey: "autopistauraba",
              },
              {
                type: "collapse",
                name: "AutRioGrande",
                key: "autriogrande",
                iconKey: "WavesIcon",
                route: "/autopistariogrande",
                componentKey: "AutRioGrande",
                public: false,
                permissionKey: "autriogrande",
              },
              {
                type: "collapse",
                name: "AutoviaBts",
                key: "btsconcesionario",
                iconKey: "MultipleStopIcon",
                route: "/btsconcesionario",
                componentKey: "BtsConcesionario",
                public: false,
                permissionKey: "btsconcesionario",
              },
              {
                type: "collapse",
                name: "AutoviaNeivaGirardot",
                key: "autovianeivagirardot",
                iconKey: "ForkRightIcon",
                route: "/autovianeivagirardot",
                componentKey: "AutoviaNeivaGirardot",
                public: false,
                permissionKey: "autovianeivagirardot",
              },
              {
                type: "collapse",
                name: "Coviandina",
                key: "coviandina",
                iconKey: "TerrainIcon",
                route: "/coviandina",
                componentKey: "Coviandina",
                public: false,
                permissionKey: "coviandina",
              },
              {
                type: "collapse",
                name: "Covioriente",
                key: "covioriente",
                iconKey: "EastIcon",
                route: "/covioriente",
                componentKey: "Covioriente",
                public: false,
                permissionKey: "covioriente",
              },
              {
                type: "collapse",
                name: "Covipacifico",
                key: "covipacifico",
                iconKey: "WestIcon",
                route: "/covipacifico",
                componentKey: "Covipacifico",
                public: false,
                permissionKey: "covipacifico",
              },
              {
                type: "collapse",
                name: "Devimar",
                key: "devimar",
                iconKey: "SailingIcon",
                route: "/devimar",
                componentKey: "Devimar",
                public: false,
                permissionKey: "devimar",
              },
              {
                type: "collapse",
                name: "Devimed",
                key: "devimed",
                iconKey: "DirectionsCarIcon",
                route: "/devimed",
                componentKey: "Devimed",
                public: false,
                permissionKey: "devimed",
              },
              {
                type: "collapse",
                name: "Devisab",
                key: "devisab",
                iconKey: "GridViewIcon",
                route: "/devisab",
                componentKey: "Devisab",
                public: false,
                permissionKey: "devisab",
              },
              {
                type: "collapse",
                name: "Findeter",
                key: "findeter",
                iconKey: "AssuredWorkloadIcon",
                route: "/findeter",
                componentKey: "Findeter",
                public: false,
                permissionKey: "findeter",
              },
              {
                type: "collapse",
                name: "Iccu",
                key: "iccu",
                iconKey: "EngineeringIcon",
                route: "/iccu",
                componentKey: "Iccu",
                public: false,
                permissionKey: "iccu",
              },
              {
                type: "collapse",
                name: "La Pintada",
                key: "lapintada",
                iconKey: "PaletteIcon",
                route: "/lapintada",
                componentKey: "LaPintada",
                public: false,
                permissionKey: "lapintada",
              },
              {
                type: "collapse",
                name: "Pacifico Tres",
                key: "pacificotres",
                iconKey: "Looks3Icon",
                route: "/pacificotres",
                componentKey: "PacificoTres",
                public: false,
                permissionKey: "pacificotres",
              },
              {
                type: "collapse",
                name: "Panamericana",
                key: "panamericana",
                iconKey: "PublicIcon",
                route: "/panamericana",
                componentKey: "Panamericana",
                public: false,
                permissionKey: "panamericana",
              },
              {
                type: "collapse",
                name: "Peajes Nacionales",
                key: "peajesnacionales",
                iconKey: "FlagIcon",
                route: "/peajesnacionales",
                componentKey: "PeajesNacionales",
                public: false,
                permissionKey: "peajesnacionales",
              },
              {
                type: "collapse",
                name: "Pisa",
                key: "pisa",
                iconKey: "MapIcon",
                route: "/pisa",
                componentKey: "Pisa",
                public: false,
                permissionKey: "pisa",
              },
              {
                type: "collapse",
                name: "Pob",
                key: "pob",
                iconKey: "ExploreIcon",
                route: "/pob",
                componentKey: "Pob",
                public: false,
                permissionKey: "pob",
              },
              {
                type: "collapse",
                name: "Ruta al Mar",
                key: "rutaalmar",
                iconKey: "BeachAccessIcon",
                route: "/rutaalmar",
                componentKey: "RutaalMar",
                public: false,
                permissionKey: "rutaalmar",
              },
              {
                type: "collapse",
                name: "Ruta al Sur",
                key: "rutaalsur",
                iconKey: "SouthIcon",
                route: "/rutaalsur",
                componentKey: "RutaAlSur",
                public: false,
                permissionKey: "rutaalsur",
              },
              {
                type: "collapse",
                name: "Ruta del Cacao",
                key: "rutadelcacao",
                iconKey: "ParkIcon",
                route: "/rutadelcacao",
                componentKey: "RutaDelCacao",
                public: false,
                permissionKey: "rutadelcacao",
              },
              {
                type: "collapse",
                name: "Ruta del Valle",
                key: "rutadelvalle",
                iconKey: "LandscapeTwoToneIcon",
                route: "/rutadelvalle",
                componentKey: "RutaDelValle",
                public: false,
                permissionKey: "rutadelvalle",
              },
              {
                type: "collapse",
                name: "Ruta M Sierra Mar",
                key: "rutamsierramar",
                iconKey: "HikingIcon",
                route: "/rutamsierramar",
                componentKey: "RutaMSierraMar",
                public: false,
                permissionKey: "rutamsierramar",
              },
              {
                type: "collapse",
                name: "Ruta Portuaria",
                key: "rutaportuaria",
                iconKey: "DirectionsBoatIcon",
                route: "/rutaportuaria",
                componentKey: "RutaPortuaria",
                public: false,
                permissionKey: "rutaportuaria",
              },
              {
                type: "collapse",
                name: "Sabana Occidente",
                key: "sabanaocc",
                iconKey: "WbTwilightIcon",
                route: "/sabanaocc",
                componentKey: "SabanaOcc",
                public: false,
                permissionKey: "sabanaocc",
              },
              {
                type: "collapse",
                name: "Sisga",
                key: "sisga",
                iconKey: "WaterDropIcon",
                route: "/sisga",
                componentKey: "Sisga",
                public: false,
                permissionKey: "sisga",
              },
              {
                type: "collapse",
                name: "Tunel del Oriente",
                key: "tuneldeloriente",
                iconKey: "SubwayIcon",
                route: "/tuneldeloriente",
                componentKey: "TunelDelOriente",
                public: false,
                permissionKey: "tuneldeloriente",
              },
              {
                type: "collapse",
                name: "Union del Sur",
                key: "uniondelsur",
                iconKey: "SouthEastIcon",
                route: "/uniondelsur",
                componentKey: "UnionDelSur",
                public: false,
                permissionKey: "uniondelsur",
              },
              {
                type: "collapse",
                name: "Vias Del Nus",
                key: "viasdelnus",
                iconKey: "AddRoadIcon",
                route: "/viasdelnus",
                componentKey: "ViaDelNus",
                public: false,
                permissionKey: "viasdelnus",
              },
              {
                type: "collapse",
                name: "Via 40 Express",
                key: "via40express",
                iconKey: "SpeedIcon",
                route: "/via40express",
                componentKey: "Via40Express",
                public: false,
                permissionKey: "via40express",
              },
              {
                type: "collapse",
                name: "Via de los Llanos",
                key: "viadelosllanos",
                iconKey: "GrassIcon",
                route: "/viadelosllanos",
                componentKey: "Viadelosllanos",
                public: false,
                permissionKey: "viadelosllanos",
              },
              {
                type: "collapse",
                name: "Via Montes de Maria",
                key: "viamontesdemaria",
                iconKey: "NatureIcon",
                route: "/viamontesdemaria",
                componentKey: "ViaMontesDeMaria",
                public: false,
                permissionKey: "viamontesdemaria",
              },
              {
                type: "collapse",
                name: "Via Rio Pamplonita",
                key: "viariopamplonita",
                iconKey: "StreamIcon",
                route: "/viariopamplonita",
                componentKey: "ViaRioPamplonita",
                public: false,
                permissionKey: "viariopamplonita",
              },
              {
                type: "collapse",
                name: "Yuma",
                key: "yuma",
                iconKey: "RouteIcon",
                route: "/yuma",
                componentKey: "Yuma",
                public: false,
                permissionKey: "yuma",
              },
            ],
            public: false,
            permissionKey: "peajes",
          },
        ],
        public: false,
        permissionKey: "conciliaciones",
      },
    ],
    public: false,
    permissionKey: "finops",
  },
  {
    type: "collapse",
    name: "Indicadores",
    key: "indicadores",
    iconKey: "BarChartIcon",
    route: "/indicadores",
    componentKey: "Indicadores",
    public: false,
    permissionKey: "indicadores",
  },
  {
    type: "collapse",
    name: "Noc",
    key: "noc",
    iconKey: "SupportAgentIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Alertas",
        key: "alertas",
        iconKey: "NotificationsActiveIcon",
        route: "/alertas",
        componentKey: "Alertas",
        public: false,
        permissionKey: "alertas",
      },
      {
        type: "collapse",
        name: "Auditoria",
        key: "auditoria",
        iconKey: "PolicyIcon",
        route: null,
        collapse: [
          {
            type: "collapse",
            name: "Parking",
            key: "parking",
            iconKey: "LocalParkingIcon",
            route: "/parking",
            componentKey: "Parking",
            public: false,
            permissionKey: "parking",
          },
        ],
        public: false,
        permissionKey: "auditoria",
      },
    ],
    public: false,
    permissionKey: "noc",
  },
  {
    type: "collapse",
    name: "Monitoreo",
    key: "monitoreo",
    iconKey: "RadarIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Redes",
        key: "redes",
        iconKey: "RouterIcon",
        route: "/redes",
        componentKey: "Redes",
        public: false,
        permissionKey: "redes",
      },
      {
        type: "collapse",
        name: "Readers",
        key: "readers",
        iconKey: "SensorsIcon",
        route: "/readers",
        componentKey: "Readers",
        public: false,
        permissionKey: "readers",
      },
      {
        type: "collapse",
        name: "Camaras",
        key: "camaras",
        iconKey: "VideocamIcon",
        route: "/camaras",
        componentKey: "Camaras",
        public: false,
        permissionKey: "camaras",
      },
      {
        type: "collapse",
        name: "Creacion Ciclo",
        key: "creacionCiclo",
        iconKey: "AutorenewIcon",
        route: "/creacionCiclo",
        componentKey: "CrearCiclo",
        public: false,
        permissionKey: "creacionCiclo",
      },
      {
        type: "collapse",
        name: "Ciclos Accespark",
        key: "ciclosAccespark",
        iconKey: "EventRepeatIcon",
        route: "/ciclosAccespark",
        componentKey: "CiclosAccespark",
        public: false,
        permissionKey: "cierreCiclo",
      },
      {
        type: "collapse",
        name: "Ciclos Ezytec",
        key: "ezytecCiclo",
        iconKey: "SyncIcon",
        route: "/ezytecCiclo",
        componentKey: "EzytecCiclo",
        public: false,
        permissionKey: "ezytecCiclo",
      },
      {
        type: "collapse",
        name: "Cerberus",
        key: "cerberus",
        iconKey: "ShieldIcon",
        route: "/cerberus",
        componentKey: "Cerberus",
        public: false,
        permissionKey: "cerberus",
      },
      {
        type: "collapse",
        name: "Placas",
        key: "placas",
        iconKey: "PinIcon",
        route: "/placas",
        componentKey: "Placas",
        public: false,
        permissionKey: "placas",
      },
    ],
    public: false,
    permissionKey: "monitoreo",
  },
  {
    type: "collapse",
    name: "J.A.R.V.I.S",
    key: "jarvis",
    iconKey: "SmartToyIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Comercios",
        key: "comerciosJarvis",
        iconKey: "StoreIcon",
        route: "/ComerciosJarvis",
        componentKey: "ComerciosJarvis",
        public: false,
        permissionKey: "comerciosJarvis",
      },
      {
        type: "collapse",
        name: "Whatsapp",
        key: "whatsappJarvis",
        iconKey: "WhatsAppIcon",
        route: "/WhatsappJarvis",
        componentKey: "WhatsappJarvis",
        public: false,
        permissionKey: "whatsappJarvis",
      },
      {
        type: "collapse",
        name: "Copropiedades W",
        key: "copropiedadesW",
        iconKey: "MarkChatUnreadIcon",
        route: "/CopropiedadesWhatsapp",
        componentKey: "WhatsappCop",
        public: false,
        permissionKey: "copropiedadesW",
      },
    ],
    public: false,
    permissionKey: "jarvis",
  },
  {
    type: "collapse",
    name: "Seguridad",
    key: "seguridad",
    iconKey: "SecurityIcon",
    route: null,
    collapse: [
      {
        type: "collapse",
        name: "Roles",
        key: "rol",
        iconKey: "AdminPanelSettingsIcon",
        route: "/rol",
        componentKey: "Rol",
        public: false,
        permissionKey: "roles",
      },
      {
        type: "collapse",
        name: "Usuarios",
        key: "usuario",
        iconKey: "PeopleAltIcon",
        route: "/usuario",
        componentKey: "Usuario",
        public: false,
        permissionKey: "usuarios",
      },
    ],
    public: false,
    permissionKey: "seguridad",
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    iconKey: "LoginIcon",
    route: "/authentication/sign-in",
    componentKey: "SignIn",
    public: true,
    permissionKey: "sign-in",
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    iconKey: "PersonAddAlt1Icon",
    route: "/authentication/sign-up",
    componentKey: "SignUp",
    public: true,
    permissionKey: "sign-up",
  },
];

export default navigation;
